



































































































































































































































































































import { mapState, mapGetters, mapActions } from 'vuex'
import ReportButton from '~/components/car/classifieds/view/partials/Header/ReportButton.vue'
import ShareButton from '~/components/car/classifieds/view/partials/Header/ShareButton.vue'
import UtilButtons from '~/components/car/classifieds/view/partials/UtilButtons.vue'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import SalaryOrPayment from '~/components/car/classifieds/view/partials/Price/SalaryOrPayment.vue'
import Specifications from '~/components/car/classifieds/view/partials/Specifications.vue'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import Contact from '~/components/car/classifieds/view/partials/Contact.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import Notes from '~/components/car/classifieds/view/partials/Notes.vue'
import SellerInfo from '~/components/car/classifieds/view/partials/seller/SellerInfo.vue'
import ClassifiedListsButton from '~/components/shared/parking/partials/ClassifiedListsButton.vue'
import QuickSellerInfo from '~/components/shared/classified/view/QuickSellerInfo.vue'
import RequestsEmployeeBadge from '~/components/car/classifieds/badges/RequestsEmployeeBadge.vue'
import RequestsWorkBadge from '~/components/car/classifieds/badges/RequestsWorkBadge.vue'
import { comparableRootCategoryIds } from '~/constants/compare'
import CClassifiedCompareButton from '~/components/shared/configurable/classified/compare/CClassifiedCompareButton.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import PromoteBlock from '~/components/car/classifieds/view/partials/PromoteBlock.vue'
import PromotedBadge from '~/components/car/classifieds/badges/PromotedBadge.vue'
import CAdmanAd from '~/components/shared/configurable/ad/CAdmanAd.vue'
import ContactPrompt from '~/components/car/classifieds/view/partials/ContactPrompt.vue'

import { ADS_NS } from '~/store/modules/shared/ads/state'
import PaidClassifiedBadge from '~/components/car/classifieds/badges/PaidClassifiedBadge.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import PrintButton from '~/components/car/classifieds/view/partials/Header/PrintButton.vue'
import CFloatingContactParking from '~/components/shared/configurable/CFloatingContactParking.vue'
import ClassifiedViewAd from '~/components/car/classifieds/view/ClassifiedViewAd.vue'
import CompareService from '~/services/compare/CompareService'
import RelatedClassifiedsAndSearches from '~/components/shared/classified/view/RelatedClassifiedsAndSearches.vue'
import { elementLargerThanScreen } from '~/utils/dom'
import PerpetratorInfo from '~/components/car/classifieds/view/admin/PerpetratorInfo.vue'
import { createPhotoUrlWithSize } from '~/utils/photos'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CPosting,
    RelatedClassifiedsAndSearches,
    PaidClassifiedBadge,
    PromotedBadge,
    PromoteBlock,
    PrintButton,
    ProtectedUtilButtons: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/ProtectedUtilsButtons/ProtectedUtilButtons.vue'
      )
    ),
    Description: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Description.vue')
    ),
    UtilButtons,
    Extras: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Extras.vue')
    ),
    Certificates: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Certificates.vue')
    ),
    ImagesRow: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/ImagesRow.vue')
    ),
    CVideoEmbed: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/CVideoEmbed.vue')
    ),
    ClassifiedListsButton,
    CClassifiedFavoriteButton,
    Specifications,
    SalaryOrPayment,
    QuickSellerInfo,
    Contact,
    Title,
    ReportButton,
    ShareButton,
    Notes,
    SellerInfo,
    RequestsEmployeeBadge,
    RequestsWorkBadge,
    CClassifiedCompareButton,
    CAdmanAd,
    ContactPrompt,
    CFloatingContactParking,
    ClassifiedViewAd,
    PerpetratorInfo
  },
  data() {
    return {
      forceBottom: false
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => state.classified,
      seller: state => state.seller,
      currentUser: state => state.currentUser,
      showContact: state => state.showContact,
      showContactPrompt: state => state.showContactPrompt,
      nativePhotos: state => state.classified.compactPhotos.native.photos
    }),
    ...mapState(ADS_NS, {
      showAdmanAds: state => state.showAdmanAds
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerIsAnonymous: 'sellerIsAnonymous',
      userIsAdminOrOwner: 'userIsAdminOrOwner',
      userCanViewNotes: 'userCanViewNotes',
      isPromoted: 'isPromoted',
      sellerIsBlacklistedSuspiciousOrFraudster:
        'sellerIsBlacklistedSuspiciousOrFraudster',
      isJobWanted: 'isJobWanted',
      isJobOffered: 'isJobOffered',
      shouldShowProtectedUtilButtons: 'shouldShowProtectedUtilButtons',
      canViewPromotionInfo: 'canViewPromotionInfo',
      adsKeyValues: 'getKeyValues',
      paidClassified: 'paidClassified',
      descriptionContent: 'getDescriptionContent',
      classifiedHasNativePhotos: 'classifiedHasNativePhotos',
      shortVideos: 'getShortVideos'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin'
    }),
    hasNeitherSalaryNorPayment() {
      return !this.classified.payment && !this.classified.salary
    },
    showPromoBadge() {
      if (this.isPromoted) {
        return this.$route.query['from-promotion'] || this.userIsAdminOrOwner
      }
      return false
    },
    showSalaryOrPayment() {
      return this.classified.salary || this.classified.payment
    },
    showImages() {
      if (this.classified.videos.length || this.classifiedHasNativePhotos) {
        return true
      }
      return false
    },
    firstNativePhoto() {
      if (this.nativePhotos?.length) {
        return createPhotoUrlWithSize(this.nativePhotos[0].url, 'a')
      }
      return null
    },
    categoryId(): number {
      return comparableRootCategoryIds.find(c =>
        this.classified.category_ids.includes(c)
      )
    }
  },
  async updated() {
    await this.$nextTick()
    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
  },
  mounted() {
    this.$emit('mounted')

    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      classifiedParkedStateChanged: 'classifiedParkedStateChanged'
    }),
    async setCompare(refName: string) {
      const classifiedId = parseInt(this.classified.id, 10)
      const compareService = this.$dep(CompareService)
      try {
        await compareService.setComparedClassified(
          this.categoryId,
          classifiedId
        )
        this.$refs[refName].displayPopover(classifiedId)
      } catch (error) {
        this.$logger.captureError(error)
      }
    }
  }
})
